import $ from 'jquery';

$(document).on('click', '.video-block__play', function () {
    const $this = $(this);
    const parent = $this.parent();

    parent.find('.video-block__play').remove();
    parent.find('.video-block__video').show();

    if (parent.find('video').length) {
        parent.find('video')[0].play();
    } else {
        parent
            .find('iframe')
            .attr('src', parent.find('iframe').attr('src') + '&autoplay=1');

        parent.find('iframe').attr('allow', 'autoplay');
    }
});
